import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import useMediaQuery from "@mui/material/useMediaQuery";
import { buildTheme } from "./theme";
const STORAGE_KEY = "admin_color_mode";
const ColorModeContext = createContext({
    preference: "system",
    mode: "light",
    setPreference: () => undefined,
});
export function useColorMode() {
    return useContext(ColorModeContext);
}
function readPreference() {
    // eslint-disable-next-line no-undef
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark" || stored === "system") {
        return stored;
    }
    return "system";
}
export const ColorModeProvider = ({ children, }) => {
    const [preference, setPreferenceState] = useState(readPreference);
    const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
    const setPreference = useCallback((value) => {
        // eslint-disable-next-line no-undef
        localStorage.setItem(STORAGE_KEY, value);
        setPreferenceState(value);
    }, []);
    const mode = useMemo(() => {
        if (preference === "system") {
            return prefersDark ? "dark" : "light";
        }
        return preference;
    }, [preference, prefersDark]);
    const theme = useMemo(() => buildTheme(mode), [mode]);
    const value = useMemo(() => ({ preference, mode, setPreference }), [preference, mode, setPreference]);
    return (_jsx(ColorModeContext.Provider, { value: value, children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }) }));
};
